<template>
  <div class="regist_group_box">
    <el-form
      :model="query"
      ref="formLeft"
      style="margin-right:30px;"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="注册类别" required>
        <el-radio-group :disabled="isDisabledNormal" v-model="query.type" @change="typeChange">
          <el-radio :label="2">竞技项目</el-radio>
          <el-radio :label="1">阳光项目</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="注册组别" prop="group">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabledNormal"
          style="width:232px"
          v-model="query.group"
        >
          <el-option
            v-for="(item,index) in registGroup"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <template v-if="query.projectFirst && operation && isShow">
        <el-form-item label="注册项目" style="position:relative">
          <el-select
            :popper-append-to-body="false"
            style="width:232px"
            :disabled="operation === 'watch'?true:false"
            v-model="query.projectNew"
          >
            <el-option
              v-for="(temp,num) in otherProjectList"
              :key="num"
              :disabled="temp.disabled"
              :value="temp.value"
              :label="temp.label"
            ></el-option>
          </el-select>
          <p style="position:absolute;top:0;right:-40px;" v-if="operation !== 'watch'">
            <span
              style="margin:0 0 0 15px;cursor:pointer;color:#FD6666"
              @click="removeOtherProject"
            >删除</span>
          </p>
        </el-form-item>
      </template>
    </el-form>
    <el-form :model="query" ref="formRight" :rules="rules" label-width="112px">
      <el-form-item label="注册证号码">
        <el-input
          disabled
          style="width:217px"
          placeholder="请输入注册证号码"
          v-model="query.registerNumber"
        ></el-input>
      </el-form-item>
      <el-form-item label="首次注册项目" prop="projectFirst">
        <el-select
          :popper-append-to-body="false"
          :disabled="isDisabledNormal"
          v-model="query.projectFirst"
          @change="selectProject"
        >
          <el-option
            v-for="(item,index) in groupList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <p style="display:inline-block" v-if="!isShow">
          <span style="margin:0 0 0 15px;cursor:pointer;color:#1E63B0" @click="addNewProject">添加</span>
        </p>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import registerData from "@/assets/json/register.json";
export default {
  props: {
    formInfo: {
      type: Object
    },
    operation: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      otherProjectList: [],
      query: {
        type: 2,
        group: "",
        registerNumber: "",
        projectFirst: "",
        projectNew: ""
      },
      isShow: true,
      rules: {
        group: [
          { required: true, message: "注册组别不能为空", trigger: "change" }
        ],
        projectFirst: [
          { required: true, message: "注册项目不能为空", trigger: "change" }
        ]
      }
    };
  },
  computed: {
    // 表单组件默认不可修改
    isDisabledNormal() {
      if (this.operation === "watch") return true;
      if (this.formInfo && this.formInfo.name) {
        if (
          this.formInfo.state === 0 ||
          this.formInfo.state === 2 ||
          this.formInfo.state === 4
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    // 获取项目列表
    groupList() {
      if (this.query.type === 2) {
        this.otherProjectList = registerData.sportsProjectList;
        return registerData.sportsProjectList;
      } else {
        this.otherProjectList = registerData.sunshineProject;
        return registerData.sunshineProject;
      }
    },
    // 获取注册组别
    registGroup() {
      return registerData.registGroup;
    }
  },
  watch: {
    formInfo(value) {
      if (value) {
        this.isShow = true;
        for (let item in value) {
          if (this.query.hasOwnProperty(item))
            this.$set(this.query, item, value[item]);
        }
        if (!this.query.projectNew) {
          this.isShow = false;
        }
        this.selectProject(this.query.projectFirst, false);
      }
    }
  },
  methods: {
    // 添加新增注册项目
    addNewProject() {
      this.isShow = true;
    },
    // 选择首次注册项目，将其他项目对应选择项禁用,清空其他项目选项
    selectProject(value, isClear = true) {
      this.query.projectNew = isClear ? "" : this.query.projectNew;
      this.otherProjectList.filter(item => {
        if (item.value === value) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
    },
    // 删除项目
    removeOtherProject() {
      this.isShow = false;
      this.query.projectNew = "";
    },
    // 注册类别切换
    typeChange(value) {
      this.query.projectFirst = "";
      let field = this.$refs["formRight"].fields;
      field.map(i => {
        if (i.prop === "projectFirst") {
          //   //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
          i.resetField();
          return false;
        }
      });
    },
    // 表单提交验证
    submits() {
      return Promise.all([
        this.$refs["formLeft"].validate(),
        this.$refs["formRight"].validate()
      ])
        .then(res => {
          let arr = [];
          for (let item in this.otherProject) {
            if (this.otherProject[item]) arr.push(this.otherProject[item]);
          }
          if (arr.length > 0) this.query.projectNew = arr.join(",");
          return Promise.resolve(this.query);
        })
        .catch(err => {
          this.$message.warning("请完善注册组别信息");
          return null;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.regist_group_box {
  display: flex;
  /deep/ .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #606266;
  }
}
</style>